import { render, staticRenderFns } from "./baseMessage.vue?vue&type=template&id=6c10527a"
import script from "./baseMessage.vue?vue&type=script&lang=js"
export * from "./baseMessage.vue?vue&type=script&lang=js"
import style0 from "./baseMessage.vue?vue&type=style&index=0&id=6c10527a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports